// removed by extract-text-webpack-plugin
module.exports = {"overlay":"src-components-Modal----index-module---overlay---2K-Qm","overlayAfterOpen":"src-components-Modal----index-module---overlayAfterOpen---3UUDK","overlayBeforeClose":"src-components-Modal----index-module---overlayBeforeClose---2fRPF","content":"src-components-Modal----index-module---content---2i_if","button":"src-components-Modal----index-module---button---sdjNj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/index.module.css
// module id = 610
// module chunks = 114276838955818